function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "currentColor",
  d: "M.535,3.851v.012l5.9,2.691.006,0a1.327,1.327,0,0,0,1.12,0l.006,0,5.9-2.691V3.851a.56.56,0,0,0,.384-.513.558.558,0,0,0-.389-.514L7.57.124H7.559a1.322,1.322,0,0,0-1.118,0H6.43L.54,2.824a.558.558,0,0,0-.389.514A.56.56,0,0,0,.535,3.851Z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M13.46,6.485l-1.153-.529C10.5,6.783,8.03,7.909,8,7.919a2.707,2.707,0,0,1-2,0c-.028-.009-2.494-1.134-4.3-1.962L.54,6.485A.534.534,0,0,0,.535,7.512v.011l5.9,2.692.006,0a1.327,1.327,0,0,0,1.12,0l.006,0,5.9-2.692V7.512a.534.534,0,0,0,0-1.027Z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M13.46,10.148l-1.153-.529C10.5,10.447,8.03,11.573,8,11.582a2.694,2.694,0,0,1-2,0c-.028-.009-2.494-1.134-4.3-1.962L.54,10.148a.535.535,0,0,0-.005,1.028v.011l5.9,2.691.006,0a1.327,1.327,0,0,0,1.12,0l.006,0,5.9-2.691v-.011a.535.535,0,0,0,0-1.028Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/layers.72308a7a.svg";
export { SvgComponent as ReactComponent };